import {TabulatorFull as Tabulator} from 'tabulator-tables';
import Autolinker from 'autolinker';

import '../node_modules/tabulator-tables/dist/css/tabulator_semanticui.min.css';
import './css/table.css';


const csv = "csv/Points.csv";

function getSetting(s, def) {
  s = window.config[s];
  if (!s) { return def; }
  return s;
}

fetchDataCsv(csv).then((data) => {
  var data = Papa.parse(data, {
    header: true,
    skipEmptyLines: true
  }).data;

  let filterCategories = [...new Set(getSetting("_tableCategories"))];
  let tableData = data.filter(r => filterCategories.includes(r.Kategorie));

  let columns = getSetting("_tableColumns");
  var autolinker = new Autolinker( { newWindow: true } );

  var table = new Tabulator("#events-table", {
    data: tableData,
    height: "100%",
    //layout: "fitColumns",
    layout: "fitDataFill",
    headerVisible: false,
    groupBy: ["Kategorie", "Gruppe"],
    responsiveLayout: "collapse",
    autoColumns: true,
    locale: true,
    responsiveLayoutCollapseFormatter:function(data){
        //data - an array of objects containing the column title and value for each cell
        var table = document.createElement("table");

        data.forEach(function(column){
            let item = document.createElement("tr");
            if (column.field == "Beschreibung") {
              item.innerHTML = "<td><strong>" + column.title + "</strong></td><td style=\"white-space: pre-wrap;\">" + column.value + "</td>";
            } else if (column.field == "Image") {
              item.innerHTML = "<td><strong>" + column.title + "</strong></td><td><a href=\"" + column.value.currentSrc + "\"><img src=\"" + column.value.currentSrc + "\" style=\"width: 200px;\"></img></a></td>";
            } else {
              item.innerHTML = "<td><strong>" + column.title + "</strong></td><td>" + column.value + "</td>";
            }
            table.appendChild(item);
        });

        return Object.keys(data).length ? table : "";
    },
    autoColumnsDefinitions:function(definitions){
      definitions.forEach((column) => {
        if (!columns.includes(column.field)) {
          column.visible = false;
        }
        if (column.field == "Beschreibung") {
          column.maxWidth = "400px";
          column.responsive = 2;
          column.cssClass = "description-column";
	  column.formatter = function(cell, formatterParams, onRendered) {
            return cell.getValue().replace("<br/>", "\n"); //return the contents of the cell;
          };
          //column.formatter = "textarea";
          //column.formatter = "html";
        } else if (column.field == "Kategorie") {
          column.visible = false
        } else if (column.field == "Gruppe") {
          column.visible = false
        } else if (column.field == "Adresse") {
          column.responsive = 4;
	  column.formatter = function(cell, formatterParams, onRendered) {
            var rowdata = cell.getData();
            return "<a href=\"index.html?lat=" + rowdata.Latitude + "&lon=" + rowdata.Longitude + "&zoom=16\">" + cell.getValue() + "</a>";
          };
          //column.formatter = "html";
        } else if (column.field == "Datum") {
          column.responsive = 3;
          column.formatter = "html";
        } else if (column.field == "Kontakt") {
          column.responsive = 6;
	  column.formatter = function(cell, formatterParams, onRendered) {
            return autolinker.link(cell.getValue()); //return the contents of the cell;
          }
        } else if (column.field == "Online") {
          column.responsive = 7;
	  column.formatter = function(cell, formatterParams, onRendered) {
            return autolinker.link(cell.getValue()); //return the contents of the cell;
          }
        } else if (column.field == "Image") {
          column.responsive = 5;
          column.formatterParams = {
            width: "100px"
          };
	  //column.formatter = function(cell, formatterParams, onRendered) {
          //  return "<td><a href=\"" + cell.getValue() + "\"><img src=\"" + cell.getValue() + "\" width=\"200px\" height=\"auto\"></img></a></td>"
          //};
          column.formatter = "image";
        }
      });
      definitions.unshift({formatter:"responsiveCollapse", width:30, minWidth:30, hozAlign:"center", resizable:false, headerSort:false});
      return definitions;
    },
  });

  //const rows = table.getRows();
  //rows.forEach(function(row) {
  //  row.normalizeHeight();
  //});
  //table.redraw();

  //table.addColumn({formatter:"responsiveCollapse", width:30, minWidth:30, hozAlign:"center", resizable:false, headerSort:false}, true, "Name");

});

async function fetchDataCsv(url) {
  try {
    const response = await fetch(url);
    const data = await response.text();
    return data;
  } catch (err) {
    console.error(err);
  }
}

